module.exports = __webpack_public_path__ + "img/patientInformation.4aaf297a.svg";